import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Data Cleaning',
  content: `
Pliable makes it easy to clean your source data, whether it's with no-code drag-and-drop tools or a full-blown DBT editor. With Pliable, you can effectively filter your incoming data. This can be accomplished by setting explicit rules or through the use of custom SQL. This feature gives you the ability to manage your data in a more precise manner, ensuring that only relevant data is incorporated into your analysis and visualizations.

Data cleaning in Pliable covers three main areas:

- **[Column Formatting](/docs/column-formatting)** — Rename, retype, and transform columns
- **[Filtering](/docs/filtering)** — Set rules to determine which records come through
- **[Grouping Behaviors](/docs/grouping-behaviors)** — Control how records are combined or aggregated
`,
};

export default doc;
